module.exports = __webpack_public_path__ + "static/33-arabspring-dec2010-db5b9f0b805a5d52eaff49cac1714086.jpg";